<template>
    <div>
        <TableView registerName="Liberação"
                    :onSearch="getConsulta"
                    :onFilter="getConsulta"
                    :tableData="tableData"
                    :tableHead="tableHead"
                    :pagination="pagination"
                    :response="response"
                    :disableCheckAll=true
                    :filterBadge="filterBadge"
                    :loadingTable="config.loading.table">
            <div slot="table-filter-content">
                <ed-form :data="formFilter" :config="config" :response="response" :itens="filterItems" />
            </div>
        </TableView>
    </div>
</template>

<script>
import Rest from "common/rest";
import EdForm from "common/form";
import EdButton from "common/button";
import TableView from 'common/table'
import FilterItems from './_form/consulta-filtro'

export default {
  components: {
    TableView,
    EdForm,
    EdButton,
  },
  mixins: [Rest],
  data() {
    return {
      config: {
        tipo: [46],
        click: {},
        list: {
          id_cre: [],
          id_funcionario: [],
        },
        loading: {
          id_cre: false,
          id_funcionario: false,
          table: false,
        },
        disabled: {
          id_funcionario: false,
          id_fdt: true,
        }
      },
      formFilter: {
        id_tipo_status: [66],
        id_tipo_aso: [],
        created_at: [],
        deleted: 0
      },
      filterBadge: 0,
      loadingTable: false,
      consulta: null,
      pagination: {},
      response: {},
      tableData: [],
      filterItems: [],
      tableHead: [{
          key: 'id_con',
          sortable: true,
          label: 'Consulta',

        },
        {
          key: 'dt_cad',
          sortable: true,
          label: 'Data',

        },
        {
          key: 'credenciada',
          sortable: true,
          label: 'Credenciada',

        },
        {
          key: 'funcionario',
          sortable: true,
          label: 'Funcionário',
        },
        {
          key: 'funcao',
          sortable: true,
          show_tipo_aso: true,
          label: 'Função',
        },
        {
          key: 'status',
          show_status: true,
          sortable: true,
          label: 'Status',
        }
      ]
    };
  },
  mounted() {
    this.getConsulta();
    this.filterItems = FilterItems;
  },
  methods: {
    onSearchASO(data){
        this.open('consulta/aso/'+this.toMd5(data.id_con));
    },
    getConsulta(search, page, pagination) {


      this.config.loading.table = true;

      if (!this.formFilter.created_at) {
        this.formFilter.created_at = [];
      }

      this.filterBadge = (
        (this.formFilter.created_at.length > 0 ? 1 : 0) +
        (this.formFilter.id_tipo_aso.length)
      );

      this.get("consulta/liberacao", {
        search: search,
        page: page,
        pagination: pagination,
        filter: this.formFilter
      }).then(result => {

        result = result[0];
        this.config.loading.table = false;
        this.response = result;

        var data = [],
          tableData = [],
          pagination = {};

        if (result.status == 200) {
          data = result.data.data;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              id_con: (data[i].id_con ? data[i].id_con : '---'),
              credenciada: (data[i].credenciada ? data[i].credenciada.nome : null),
              funcionario: (data[i].funcionario ? data[i].funcionario.nome : null),
              funcao: (data[i].funcao ? data[i].funcao.nome : null),
              ghe: (data[i].ghe ? data[i].ghe.ghe + ' (' + data[i].ghe.descricao + ')' : null),
              tipo_consulta: (data[i].tipo_aso ? data[i].tipo_aso.descricao : null),
              status: (data[i].info),
              dt_cad: this.toDate(data[i].dt_cad, true),
              _data: data[i],
              options: {
                disable_edit: true,
                disable_delete: true,
              },
              buttons: []
            };

            if (!data[i].deleted_at) {
              item.buttons.push({
                color: 'info',
                icon: 'fa fa-file-pdf-o',
                title: 'Imprimir ASO',
                click: this.onSearchASO
              })
            }
            tableData.push(item);
          }

          pagination = result.data;
        }
        this.config.loading.table = false;
        this.tableData = tableData;
        this.pagination = pagination;
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?5776fcba